import { getI18nLocale } from '@front/i18n';

export const formatFloatNumber = (number: number) => new Intl.NumberFormat(getI18nLocale()).format(number);

export const parseIntNumber = (numberStr: string) => (numberStr ? parseInt(numberStr, 10) : null);
